<template>
<div class="action-flow-node" style="height: 240px;">
	<div class="action-flow-title">Show Dialog</div>
	<div class="action-flow-hint">Show a dialog box with a message or choice.</div>
	
	<ActionParamHint label="Buttons" hint="What kind of buttons to show." param-class="param-config" 
		param-input-type="select"  param-input-label="Button type" @param-change="handleParamChange"
		:param-input-options="[{ value: 'ok', label: 'OK Only' }, { value: 'ok-cancel', label: 'OK / Cancel' }, { value: 'yes-no', label: 'Yes / No' }, { value: 'yes-no-cancel', label: 'Yes / No / Cancel' }]"
		:param-input-value="parameters.buttons"
	/>
	<ActionParamHint label="Activate" hint="Trigger this dialog by providing an input to this." param-class="param-tgt" />
	<ActionParamHint label="Message" hint="The message text to display in the dialog. You can feed in objects to this input to use them in the message format." param-class="param-tgt" 
		param-input-type="text" param-input-label="Message format" @param-change="handleParamChange"
		:param-input-value="parameters.message"
	/>
	<ActionParamHint label="Choice" hint="The user's choice from the dialog (ok, yes, no, cancel)." param-class="param-src" />
	
	<Handle type="target" id="tgt-activate" :position="Position.Left" style="top: 135px;" />
	<Handle type="target" id="tgt-message" :position="Position.Left" style="top: 175px;" />
	<Handle type="source" id="src-choices" :position="Position.Right" style="top: 215px;" />
</div>
</template>

<script setup>
/* eslint-disable */
import { ref, watch } from 'vue'
import { Handle, Position, useNodesData, useVueFlow } from '@vue-flow/core'
import ActionParamHint from './action-param-hint.vue'

const props = defineProps({
	id: String,
});

// Access the current node's data
const nodeData = useNodesData(() => props.id);
const { updateNode } = useVueFlow()

// Store parameter values
const parameters = ref({
	buttons: '',
	message: '',
});

// Watch for changes in nodeData and update parameters accordingly
watch(nodeData, (newNodeData) => {
	if (newNodeData) {
		parameters.value = {
			buttons: newNodeData.data?.buttons || '',
			message: newNodeData.data?.message || '',
		};
	}
}, { immediate: true });

// Handle parameter changes from ActionParamHint components
const handleParamChange = (paramData) => {
	// Store the parameter value based on the label
	let key = paramData.label.toLowerCase();
	if (!(key in parameters.value)) {
		console.error(`Unknown parameter label: ${paramData.label}`);
		return;
	}
	parameters.value[key] = paramData.value;
	
	// Update the node data in Vue Flow.
	updateNode(props.id, (node) => ({
		data: {
			...node.data,
			...parameters.value
		}
	}));
}
</script>

